import { motion } from 'framer-motion';
import OnboardingMascotVideo from '@/components/mascot/OnboardingMascotVideo';
import LoadingSpinner from '@/components/ui/LoadingSpinner';
import { cn } from '@/utils/cn';
import { pageContainer, pageItem } from '@/utils/animations';

interface LoadingPageProps {
  className?: string;
  isExiting?: boolean;
  onExitComplete?: () => void;
  onLoadingAnimationReady?: () => void;
}

const LoadingPage = ({ className, isExiting = false, onExitComplete, onLoadingAnimationReady }: LoadingPageProps) => {
  return (
    <motion.div
      className={cn(
        'min-h-screen bg-white flex flex-col items-center justify-center',
        'px-6 py-8',
        'relative overflow-hidden',
        className
      )}
      variants={pageContainer}
      initial="hidden"
      animate={isExiting ? { opacity: 0 } : 'visible'}
      transition={isExiting ? { duration: 0.35, ease: 'easeInOut' } : undefined}
      onAnimationComplete={isExiting ? onExitComplete : undefined}
      dir="rtl"
    >
      <div className="flex-1 flex flex-col items-center justify-center w-full max-w-sm mx-auto">
        <motion.div
          className="mb-8"
          variants={pageItem}
          style={{ marginTop: '30vh' }}
        >
          <OnboardingMascotVideo size="xxl" onReady={onLoadingAnimationReady} />
        </motion.div>

        <motion.div
          className="mb-16"
          variants={pageItem}
        >
          <LoadingSpinner size="lg" />
        </motion.div>
      </div>

    </motion.div>
  );
};

export default LoadingPage;
